import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

import { getPsapId } from '@/app/auth/claims';

declare global {
  interface Window {
    userData?: { psapId?: string; username?: string };
  }
}

export function UserInfoToConsole() {
  const auth = useAuth();

  useEffect(() => {
    const username = auth.user?.profile.name;
    const psapId = getPsapId(auth.user);

    window.userData = { psapId, username };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
